"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
exports.StringClass = {
    '+': (obj, param) => {
        return {
            name: tokens_1.LiteralTokens.StringLiteral,
            image: String(param.image + obj.image),
        };
    },
    '<': (obj, param) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image.length < param.image.length),
        };
    },
    '<=': (obj, param) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image.length <= param.image.length),
        };
    },
    '>': (obj, param) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image.length > param.image.length),
        };
    },
    '>=': (obj, param) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image.length >= param.image.length),
        };
    },
    '=': (obj, param) => {
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image === param.image),
        };
    },
};
